import React, { useEffect } from 'react'
import useSWR from 'swr'

import { getLatest } from '@/data/api/feed'
import TrailAnimation from '@/components/common/trail-animation'
import { Sound, Album } from '../../components/app/media'
import { MediaIndex } from '@/interfaces/algolia'

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  latest?: MediaIndex[]
  page: number
  noMore: () => void
  loaded: () => void
}

const Latest = ({ latest, page, noMore, loaded }: Props) => {
  const { data: latestData, error } = useSWR([ '/feed/latest/', page ], () => getLatest(20, page), {
    fallbackData: latest,
  })

  useEffect(() => {
    if (!latestData || error) {
      return
    }
    loaded()
    if (latestData.length === 0) {
      noMore()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ error, latestData ])

  if (!latestData || error) {
    return null
  }

  return (
    <>
      {latestData.map((media) => (
        <TrailAnimation key={`fetature-${page}-${media.id}`}>
          {media.mediaType === 'sound' && !!media && (
            <Sound sound={media} />
          )}
          {media.mediaType === 'album' && !!media && (
            <Album album={media} />
          )}
        </TrailAnimation>
      ))}
    </>
  )
}

export default Latest
